import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from 'usehooks-ts';
import cx from 'classnames';
import { Transition } from '@headlessui/react';
import Modal from '@molecules/modal';
import ReactDOM from 'react-dom';
import { useMobxStores } from '@stores/store';
import { observer } from 'mobx-react';
import NoSSR from '@molecules/NoSSR';
import SlideDialog from '@molecules/modal/SlideDialog';
import { cookiesDialogData } from '@molecules/data/consent/cookies.dialog';
import { consentCookiesKey, expireConfig } from '@stores/SettingStore';
import moment from 'moment';
import { saveConsentCookiesTimes } from '@helpers/Util';

const Portal = ({ children }) => {
  return ReactDOM.createPortal(children, document.querySelector('body'));
};

const GdprDialog = () => {
  const { settingStore } = useMobxStores();
  const { t } = useTranslation();
  const { width } = useWindowSize();

  const onClose = () => {
    settingStore.setGdprDialogState(false);
  };
  const openDetailLayer = () => {
    settingStore.setGdprDetailDialogState(true);
  };

  const onSave = () => {
    const checkedListArray = [];
    cookiesDialogData.forEach(e =>
      e.isUse ? checkedListArray.push(e.type) : ''
    );

    localStorage.setItem(
      consentCookiesKey.cookies,
      JSON.stringify(checkedListArray)
    );
    saveConsentCookiesTimes();

    settingStore.setGdprDialogState(false);
    settingStore.setGdprDetailDialogState(false);
  };

  const onDisagree = () => {
    settingStore.setGdprDialogState(false);
    settingStore.setGdprDetailDialogState(false);
  };

  return (
    <NoSSR>
      <Portal>
        <SlideDialog
          isOpen={settingStore.gdprDialogState}
          onClose={() => onClose()}
        >
          <div className="fixed bg-[#F4F6FA] p-2 text-left bottom-0 border-t-[3px] border-primary w-full clear overflow-hidden  md:py-[20px]">
            <div className={'py-2 text-left float-left text-xs md:text-[15px]'}>
              {t(
                '편리한 인더섬 with BTS 경험을 위해 쿠키 수집에 동의해주세요.'
              )}
              <a
                className="underline decoration-1 pl-[5px]"
                href="/policy/cookies"
              >
                {t('자세히 보기')}
              </a>
            </div>
            <div className={'float-right'}>
              <a
                onClick={onDisagree}
                className="cursor-pointer mr-5 underline text-[#666] text-xs md:text-[15px] "
              >
                {t('동의하지않고 계속하기')}
              </a>
              <span
                className="cursor-pointer text-white rounded-[12px] bg-primary  p-[6px] text-xs mr-1 align-middle border-primary border md:text-[15px] md:rounded-[15px] inline-block mr-3"
                onClick={onSave}
              >
                {t('전체 동의')}
              </span>
              <span
                onClick={openDetailLayer}
                className="cursor-pointer text-primary rounded-[12px] bg-white  p-[6px] text-xs mr-1 align-middle  border-primary border md:text-[15px] md:rounded-[15px] inline-block"
              >
                {t('선택 동의')}
              </span>
            </div>
          </div>
        </SlideDialog>
      </Portal>
    </NoSSR>
  );
};

export default observer(GdprDialog);
